import type { BookedLesson } from './use-bookings.js';

/**
 * Where a lesson opens.
 *
 * ONE CHILD'S PAGE IS THE LESSON (ruled 10 and 12 October). Each athlete has
 * their own record, so the page with the note, the plan and Cancel is one
 * child's. A booking holding two children opens a page listing both, each a
 * row to their own; a booking holding one opens that child's page directly,
 * because a list of one is a push for nothing (RE-22).
 *
 * `from=person` is carried when the way in was a person's page, so the back
 * chevron returns there rather than to the Lessons tab.
 */
export function lessonLink(lesson: BookedLesson): string {
  const only = lesson.attendees.length === 1 ? lesson.attendees[0] : undefined;
  return only?.lesson_id
    ? athleteLessonLink(lesson.booking_id, only.lesson_id)
    : `/lessons/${lesson.booking_id}`;
}

export function athleteLessonLink(bookingId: string, lessonId: string, fromPerson = false): string {
  return `/lessons/${bookingId}/${lessonId}${fromPerson ? '?from=person' : ''}`;
}
